import { useEffect, useMemo, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { HotelAPI } from '../../api/HotelAPI';
import { Facility, HotelListType, HotelType, Restaurant} from '../../types/HotelType';
import { ListHotelImageCarousel } from '../List/ListHotelItem/ListHotelImageCarousel/ListHotelImageCarousel';


export function ModalTabs ( {hotel, showRenovationNotice}: {hotel: HotelListType, showRenovationNotice?: boolean}) {

    const [hotelFull, setHotelFull] = useState<HotelType | null>(null);
    const [loading, setLoading] = useState(false);
    const hotelAPI = useMemo(() => new HotelAPI(process.env.NEXT_PUBLIC_API_BASE_URL ?? ''), []);

    useEffect(() => {
        if (!hotelFull) {
            setLoading(true);
            hotelAPI.get(hotel.id).then((data)  => {
                setHotelFull(data);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setLoading(false);
            }
            )
        }
    } , [hotelAPI, hotelFull, hotel.id]);

    if (hotel.err_desc || !hotel || !hotelFull && !loading) {
        return <div>We are unable to fetch information at this moment, apologies for any inconvenience.</div>
    }

    let slidesPerView = 3;
	const mql = window.matchMedia('(max-width: 768px)');
	if (mql.matches) {
		slidesPerView = 1;
	}

    const insertBeforeLastParagraph = (html: string, insertHtml: string): string => {
        const lastParagraphIndex = html.lastIndexOf('<p');
        if (lastParagraphIndex === -1) {
            // no <p> tags found, just append
            return html + insertHtml;
        }
        return html.slice(0, lastParagraphIndex) + insertHtml + html.slice(lastParagraphIndex);
    };

    return (
        <Tabs defaultFocus={true} defaultIndex={0} >
            <TabList>
                <Tab><a>OVERVIEW</a></Tab>
                <Tab><a>FACILITIES</a></Tab>
                <Tab><a>DINING</a></Tab>
                <Tab><a>POLICIES</a></Tab>
            </TabList>
            {!loading && hotelFull ? (
            <>
            <TabPanel className='scroll'>
            <ListHotelImageCarousel photos={hotel.photos} slidesPerView={slidesPerView} />
                <h2>{hotel.title}</h2>
                <p>{`${hotelFull.address_street1}, ${hotelFull.address_city}, ${hotelFull.address_region}, ${hotelFull.address_postal_code}, ${hotelFull.address_country}`}</p>
                <p className='stars' style={{width : Number(hotel.star_rating) * 20}}>
                    <span className='visuallyHidden'>{hotel.star_rating} star hotel</span>
                </p>
                <p>{hotel.desc_short}</p>
                <div>
                {ReactHtmlParser(
                    showRenovationNotice
                    ? insertBeforeLastParagraph(
                        hotelFull.intro,
                        '<p>Universal Volcano Bay will be closed for the season on 26 October 2026. ' +
                        'The park is expected to reopen on or before 1 April 2027. During this period, the walking path to Volcano Bay ' +
                        'will be unavailable. Additionally rooms with views of Volcano Bay may experience obstructed or altered views ' +
                        'due to the seasonal closure.</p>'
                        )
                    : hotelFull.intro
                )}
                </div>
            </TabPanel>
            <TabPanel className='scroll'>
                <h2>FACILITIES</h2>
                <ul>
                    {hotel.facilities.filter((facility: Facility) => facility.status === 1).map((facility: Facility, i: number) => {
                        return <li key={i}>{facility.name}</li>;
                    })}
                </ul>
                {ReactHtmlParser(hotelFull.leisure_facilities)}
            </TabPanel>
            <TabPanel className='scroll'>
                <h2>DINING</h2>
            {hotelFull.restaurants.map((restaurant: Restaurant) => {
                return (
                <>
                <h4 key={restaurant.restaurant_id}>{restaurant.title}</h4>
                <div>{ReactHtmlParser(restaurant.desc_short)}</div>
                </>
                )
            })}
            </TabPanel>
            <TabPanel className='scroll'>
                <h2>POLICIES</h2>
                {ReactHtmlParser(hotelFull!.parking_charges)}
                <h4>Accessibility</h4>
                {ReactHtmlParser(hotelFull!.accessibility)}
                <h4>Location</h4>
                {ReactHtmlParser(hotelFull!.location)}
            </TabPanel>
            </>
            ) : <>
                <TabPanel><div data-test-id='loading' className='loading mh100'></div></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                </>
            }
        </Tabs>
        )
};
